import type { ReactNode } from 'react'
import styles from './DocumentsTab.module.css'

interface DocumentsTabProps {
  workspaceFilter: ReactNode
  documentCount: ReactNode
  /**
   * The documents table.
   */
  children: ReactNode
}

export function DocumentsTab({
  workspaceFilter,
  documentCount,
  children,
}: DocumentsTabProps) {
  return (
    <div className={styles.root}>
      <div className={styles.workspaceFilter}>
        {workspaceFilter}
        {documentCount}
      </div>

      <div className={styles.documentsTable}>{children}</div>
    </div>
  )
}
